import {WmWoundImage} from '../../interfaces/wound-management/wm-wound-image';
import {LightUser} from '../../interfaces/core/light-user';
import {LightUserFactory} from '../core/light-user-factory';
import {UserService} from '../../services/core/user.service';
import {TkFile} from '../../interfaces/core/tk-file';
import {TkFileFactory} from '../core/tk-file-factory';

export class WmWoundImageFactory {

  /**
   *
   * @param wmWoundImage
   */
  public static fromObject(wmWoundImage: any): WmWoundImage {

    return new class implements WmWoundImage {
      comment: string = wmWoundImage.comment;
      fullPath: string = wmWoundImage.full_path_api;
      file: TkFile = {...TkFileFactory.new(), ...{ id: wmWoundImage.file.id }};
      fileId: number = wmWoundImage.file_id;
      user: LightUser = LightUserFactory.fromObject(wmWoundImage.user);
      userId: number = wmWoundImage.user_id;
      wmWoundDocumentationEntryUuid: string = wmWoundImage.wm_wound_documentation_entry_uuid;
      thumbnailFullPath: string = wmWoundImage.thumbnail_full_path;

      // ---------------------------------------------------------------------------------------------------------------
      id: number = wmWoundImage.id;
      uuid: string = wmWoundImage.uuid;
      modified: string = wmWoundImage.modified;
      created: string = wmWoundImage.created;
      deleted: 0 | 1 = 0;
    };
  }

  /**
   *
   * @param wmWoundImages
   */
  public static fromArray(wmWoundImages: any[]): WmWoundImage[] {
    return wmWoundImages.map(_wmWoundImage => WmWoundImageFactory.fromObject(_wmWoundImage));
  }

  /**
   *
   * @param wmWoundImage
   */
  public static toRemote(wmWoundImage: WmWoundImage): any {
    return {
      comment: wmWoundImage.comment,
      id: wmWoundImage.id,
      wm_wound_documentation_entry_uuid: wmWoundImage.wmWoundDocumentationEntryUuid,
      uuid: wmWoundImage.uuid,
      modified: wmWoundImage.modified,
      created: wmWoundImage.created
    };
  }

  /**
   *
   * @param wmWoundDocumentationEntryUuid
   */
  public static new(wmWoundDocumentationEntryUuid: string = null): WmWoundImage {
    return new class implements WmWoundImage {
      comment: string = null;
      file: TkFile = TkFileFactory.new();
      fileId: number = null;
      user: LightUser = LightUserFactory.fromUser(UserService.getUser());
      userId: number = UserService.getUser().id;
      wmWoundDocumentationEntryUuid: string = wmWoundDocumentationEntryUuid;
      fullPath: string = null;
      thumbnailFullPath: string = null;

      // ---------------------------------------------------------------------------------------------------------------
      id: number = null;
      uuid: string = null;
      modified: string = null;
      created: string = null;
      deleted: 0 | 1 = 0;
    };
  }

}
